/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TokenV2ReponseType } from './TokenV2ReponseType';
import {
    TokenV2ReponseTypeFromJSON,
    TokenV2ReponseTypeFromJSONTyped,
    TokenV2ReponseTypeToJSON,
} from './TokenV2ReponseType';

/**
 * 
 * @export
 * @interface TokenV2ResponseToken
 */
export interface TokenV2ResponseToken {
    /**
     * 
     * @type {TokenV2ReponseType}
     * @memberof TokenV2ResponseToken
     */
    type: TokenV2ReponseType;
    /**
     * 
     * @type {string}
     * @memberof TokenV2ResponseToken
     */
    token: string;
}

/**
 * Check if a given object implements the TokenV2ResponseToken interface.
 */
export function instanceOfTokenV2ResponseToken(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function TokenV2ResponseTokenFromJSON(json: any): TokenV2ResponseToken {
    return TokenV2ResponseTokenFromJSONTyped(json, false);
}

export function TokenV2ResponseTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenV2ResponseToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': TokenV2ReponseTypeFromJSON(json['type']),
        'token': json['token'],
    };
}

export function TokenV2ResponseTokenToJSON(value?: TokenV2ResponseToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': TokenV2ReponseTypeToJSON(value.type),
        'token': value.token,
    };
}

